import React, { useContext } from 'react'

import { SlideDown } from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'
import { downloadAsZip } from './utils'
import { NavContext } from '../../context/global_context'
import FileInput from '../importers/FileInput'
import { downloadErrorLogs } from '../../utils/common'
import { Link } from 'react-router-dom'

const ConnectorViewRow = ({
  vehicle,
  connectorView,
  toggleMappingActions,
  isOpen,
  deleteInstance,
  validateUpload,
  startAutoMapping,
  uploadMappingJson,
}) => {
  const [value, dispatch] = useContext(NavContext)

  return (
    <div className="w-full">
      <div className="flex flex-row items-center bg-white py-2 px-3 border-b border-tracer-dark-blue">
        <div className="w-2/6 px-2 break-all text-black">
          <div className="font-medium">{connectorView.name}</div>
          <div className="flex">
            <div className="text-xs font-light mr-5">
              {connectorView.harness_levels_ids.length} Level
              {connectorView.harness_levels_ids.length > 1 ? 's' : ''}
            </div>
            <div className="text-xs font-light">
              {connectorView.harness_ids.length} Harness
              {connectorView.harness_ids.length > 1 ? 'es' : ''}
            </div>
          </div>
          <div className="text-xs font-light">
            {`Created at: ${new Date(
              connectorView.created_at
            ).toLocaleString()}`}
          </div>
          <div className="text-xs font-light">
            {`Updated at: ${new Date(
              connectorView.updated_at
            ).toLocaleString()}`}
          </div>
        </div>
        <div className="w-1/6 px-2 break-all">
          <a
            className="inline-block text-blue-500 underline"
            href="javascript:void(null)"
            onClick={() => toggleMappingActions(connectorView)}
          >
            Actions
          </a>
        </div>
        <div className="w-1/6 px-2 break-all">
          <Link
            className="inline-block text-blue-500 underline cursor-pointer"
            to={`/vehicles/${vehicle}/connector_views/${connectorView.id}/edit`}
          >
            Edit View
          </Link>
        </div>
        <div className="w-1/6 px-2 break-all">
          <Link
            className="inline-block text-blue-500 underline cursor-pointer"
            to={`/vehicles/${vehicle}/connector_views/${connectorView?.id}/edit_mappings`}
          >
            Edit Mappings
          </Link>
        </div>
        <div className="w-1/6 px-2 break-all">
          <Link
            className="inline-block text-blue-500 underline cursor-pointer"
            to={`/vehicles/${vehicle}/connector_views/new?clone_from=${connectorView?.id}`}
          >
            Clone View
          </Link>
        </div>
        <div className="w-1/6 px-2 break-all">
          <a
            className="inline-block text-blue-500 underline cursor-pointer"
            rel="nofollow"
            data-method="validate-mapping"
            data-confirm="Are you sure? Want to validate mapping!"
            onClick={() => {
              validateUpload(connectorView?.id)
            }}
          >
            Validate Upload
          </a>
        </div>
        <div className="w-1/6 px-2 break-all">
          <a
            className="inline-block text-red-500 underline cursor-pointer"
            rel="nofollow"
            data-method="delete"
            data-confirm="Are you sure? You will delete all vehicle view mappings too!"
            onClick={() => {
              deleteInstance(connectorView?.id)
            }}
          >
            Delete View
          </a>
        </div>
      </div>
      {isOpen && (
        <SlideDown
          className="flex flex-row items-center bg-white border-b py-2 px-3"
          closed={!isOpen}
        >
          <div
            className="flex flex-row items-center w-full"
            style={{ backgroundColor: '#F8FAFC' }}
          >
            <div className="w-2/6 px-2" style={{ minHeight: '200px' }}>
              <img src={connectorView.compressed_png} />
            </div>
            <div
              className="flex flex-col w-4/6 content-start"
              style={{ minHeight: '150px' }}
            >
              <div className="flex flex-wrap flex-grow">
                <div className="w-1/3 px-2 hidden">
                  <a
                    href="javascript:void(null)"
                    className="inline-block text-blue-500 underline"
                  >
                    Export to Tracer Data repo
                  </a>
                </div>
                <div className="w-1/3 px-2 hidden">
                  <a
                    href="javascript:void(null)"
                    className="inline-block text-blue-500 underline"
                  >
                    Test in Tracer
                  </a>
                </div>
                <div className="w-1/3 px-2 hidden">
                  <a
                    href="javascript:void(null)"
                    className="inline-block text-blue-500 underline"
                  >
                    Sync in Tracer
                  </a>
                </div>
                <div className="w-1/3 px-2">
                  <a
                    className="inline-block text-blue-500 underline cursor-pointer"
                    target="_blank"
                    onClick={() => {
                      downloadAsZip(
                        connectorView?.id,
                        connectorView?.name,
                        dispatch
                      )
                    }}
                  >
                    Download as ZIP
                  </a>
                </div>
                <div className="w-1/3 px-2">
                  <FileInput
                    labelTitle={'Upload Mapping Json'}
                    key={`upload_mapping_json_${connectorView.id}`}
                    fileFieldId={`upload_mapping_json_${connectorView.id}`}
                    fileFieldName={`upload_mapping_json_${connectorView.id}`}
                    onChange={(e) => {
                      uploadMappingJson(connectorView.id, e)
                    }}
                    accept={`application/json`}
                  />
                  {connectorView?.mapping_logs?.error?.length > 0 && (
                    <div className="py-2">
                      <a
                        className={
                          'inline-block text-blue-500 underline cursor-pointer'
                        }
                        onClick={() => {
                          downloadErrorLogs(
                            connectorView?.mapping_logs?.error,
                            'connector_view_mapping_logs.txt'
                          )
                        }}
                      >
                        Download mapping logs
                      </a>
                    </div>
                  )}
                </div>
                <div className="w-1/3 px-2">
                  <a
                    className="inline-block text-blue-500 underline cursor-pointer"
                    rel="nofollow"
                    data-method="delete"
                    data-confirm="Are you sure? You will delete all vehicle view mappings too!"
                    onClick={() => {
                      startAutoMapping(connectorView.id)
                    }}
                  >
                    Start Auto Mapping
                  </a>
                </div>
              </div>
            </div>
          </div>
        </SlideDown>
      )}
    </div>
  )
}

export default ConnectorViewRow
